export const defaultFormatValue = (val: number): string => {
  if (val === 0) {
    return '$0';
  }

  const abs = Math.abs(val);

  if (abs >= 1_000_000) {
    return `$${(val / 1_000_000).toFixed(1)}M`;
  }

  if (abs >= 1_000) {
    return `$${Math.round(val / 1_000)}K`;
  }

  return `$${val}`;
};
